import React, { useEffect } from 'react';
import { ActivityTimeout } from './ActivityTimeout';
import { useTimer } from './useTimer';
import { ActivityTracker } from './ActivityTracker';
import { ActivityWarning } from './ActivityWarning';
import { ErrorBoundary } from 'components/shared/ErrorBoundary';
import { RefreshToken } from './RefreshToken';
import { datadogRum } from '@datadog/browser-rum';
import { useGetMyTokenData } from '../hooks/useGetMyTokenData';
import { spruceClaimsFieldName } from 'types/accessControl/AccessControlConstants';
import { useGetMeQuery } from 'API/BaseApi';

export const RefreshTokenContainer = () => {
  const [timer] = useTimer();
  const user = useGetMyTokenData();
  const { data } = useGetMeQuery();

  useEffect(() => {
    if (!user || !data) return;

    datadogRum.setUser({
      id: user[spruceClaimsFieldName]?.sid,
      name: data.name,
      email: data.email,
    });
  }, [user, data]);

  return (
    <ErrorBoundary>
      <ActivityTimeout timer={timer}>
        <RefreshToken timer={timer} />
        <ActivityTracker />
        <ActivityWarning timer={timer} />
      </ActivityTimeout>
    </ErrorBoundary>
  );
};
